export default {
  example: {
    test: '語言測試'
  },
  placeholder: {
    select: '請選擇',
    input: '請輸入',
    upload: '請上傳'
  }
}